export default __webpack_public_path__ + "static/aws-data-analytics-solutions-9d83fa0269a6782273ca5fd7eff9517b.jpg";